import clsx from 'clsx';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/internal/components/Brand/Brand.tsx
function Brand({
  namePrefix = "Adminer",
  nameSuffix = "Demo",
  tagline = "Template",
  className
}) {
  return /* @__PURE__ */ jsx("div", { className: clsx("adminer-Brand", className), children: /* @__PURE__ */ jsxs("div", { className: "adminer-Brand__name", children: [
    namePrefix,
    /* @__PURE__ */ jsx("b", { children: "\xB7" }),
    nameSuffix,
    /* @__PURE__ */ jsx("small", { children: tagline })
  ] }) });
}

export { Brand };
//# sourceMappingURL=chunk-EHMYFYGQ.js.map
//# sourceMappingURL=chunk-EHMYFYGQ.js.map